import script from "./gameSerchPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./gameSerchPage.vue?vue&type=script&lang=ts&setup=true"

import "./gameSerchPage.vue?vue&type=style&index=0&id=dfd273b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dfd273b0"]])

export default __exports__